import "./stats.scss";
import Faces from "../../Images/png/Faces.png";
import Buildings from "../../Images/png/Buildings.png";
import Books from "../../Images/png/Books.png";
import DubbleArrow from "../SVG/DubbleArrow";
import CircleLong from "../SVG/CircleLong";
// import Underline from "../SVG/Underline";
import UnderlineSmall from "../SVG/UnderlineSmall";
const Stats = () => {
  return (
    <section className="stats">
      <div className="tag-container">
        <p className="sub-tag">Believe it</p>
        <p className="tag">mijn ervaring in cijfers</p>
      </div>

      <div className="stats-container">
        <div>
          <div className="stat">
            <p className="number">178</p>

            <img src={Faces} alt="Faces" />
          </div>
          <div className="stat-text">
            <span className="relative">
              Mensen gecoacht.
              <div className="d-arrow">
                <DubbleArrow />
              </div>
            </span>
          </div>
        </div>
        <div>
          <div className="stat">
            <p className="number">546</p>
            <img src={Buildings} alt="buildings" />
          </div>
          <div className="stat-text">
            <span className="relative">
              Teams &nbsp;
              <div className="circle">
                <CircleLong />
              </div>
            </span>
            getraind.
          </div>
        </div>
        <div>
          <div className="stat">
            <p className="number">3</p>
            <img src={Books} alt="books" />
          </div>
          <div className="stat-text">
            <span className="relative">
              Boeken &nbsp;
              <div className="underline">
                <UnderlineSmall />
              </div>
            </span>
            geschreven.
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
